export type UserAddress = {
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string;
  city: string;
  postcode: string;
  country: string;
  state?: string;
  phone?: string;
};

export type UserEmail = {
  emailAddress: string;
  subscribed: boolean;
};

export type GetUserMeResponse = {
  userId: number;
  userName: string;
  email: string;
  displayName: string;
} | null;

export type GetUserRequest = {
  userId: number;
};

export type GetUserResponse = {
  userId: number;
  email?: UserEmail;
  address?: {
    shipping: UserAddress;
    billing: UserAddress;
  };
} | null;

export type UpdateUserRequest = {
  userId: number;
  email?: UserEmail;
  address?: {
    shipping: UserAddress;
    billing: UserAddress;
  };
};

export type UpdateUserResponse = unknown;
